import { _get } from "../../../../apiClient";
import config from "../../../../config";
import { _showToast } from "../../../../toastHelper";

export default async function FetchAndBindData(eventId, sections) {
    let eventData = await getData(eventId);
    if (eventData) {
        let data = JSON.parse(eventData.eventData);
        for (const section of sections) {
            if (section.sectionname == "invitation") {
                bindInvitationDetails(section, data);
            }
            else if (section.sectionname == "birthday") {
                bindBirthdayDetails(section, data);
            }
            else if (section.sectionname == "events") {
                bindEvents(section, data);
            }
            else if (section.sectionname == "gallery") {
                bindGallery(section, data);
            }
            else if (section.sectionname == "people") {
                bindPeople(section, data);
            }
            else if (section.sectionname == "story") {
                bindStories(section, data);
            }
            else if (section.sectionname == "studio") {
                section.data = data.studioId;
                section.isValid = true;
            }
            else if (section.sectionname == "theme") {
                bindThemeData(section, data);
            }
        }

        let titles;
        if (data.titles && data.titles.length > 0) {
            titles = data.titles;
        }
        else {
            titles = JSON.parse(eventData.themeJsonData);
        }

        return {
            sections: sections,
            eventId: eventId,
            eventCode: eventData.eventCode,
            imageCount: eventData.imageCount,
            videoCount: eventData.videoCount,
            titles: titles
        };
    }
    return null;

}

const getData = async (eventId) => {
    return await _get("/events/" + eventId)
        .then((response) => {
            return response
        })
        .catch((error) => {
            _showToast(error, "error");
            return null;
        })
}

const bindInvitationDetails = async (section, data) => {
    section.data = {
        title: data.invitation.title,
        eventDate: data.invitation.eventDate,
        imageKey: data.invitation.imageKey,
        imageFile: null,
        image: data.invitation.imageKey ? config.imagesbaseurl + data.invitation.imageKey : null,
        expiration: data.invitation.expiration,
        liveUrl: data.invitation.liveUrl
    }

    section.isValid = true;
}

const bindBirthdayDetails = async (section, data) => {
    let birthdayData = [];
    for (const birthday of data.birthday) {
        birthdayData.push({
            title: birthday.title,
            tagLine: birthday.tagLine,
            image: birthday.imageKey ? config.imagesbaseurl + birthday.imageKey : null,
            imageFile: null,
            imageKey: birthday.imageKey
        })
    }

    section.data = birthdayData;
    section.isValid = true;
}

const bindEvents = async (section, data) => {
    let events = [];
    for (const event of data.events) {
        events.push({
            title: event.title,
            date: event.date,
            time: event.time,
            venue: event.venue,
            location: event.location
        })
    }
    section.data = events;
    section.isValid = true;
}

const bindGallery = async (section, data) => {
    let gallery = [];
    for (const galleryItem of data.gallery) {
        gallery.push({
            fileId: galleryItem.fileId,
            name: galleryItem.name,
            image: galleryItem.imageKey ? config.imagesbaseurl + galleryItem.imageKey : null,
            imageKey: galleryItem.imageKey,
            imageFile: null,
            type: galleryItem.type,
            videoUrl: galleryItem.videoUrl,
            videoImage: galleryItem.videoImage,
            isPrimaryVideo: galleryItem.isPrimaryVideo ?? false
        });
    }
    section.data = gallery;
    section.isValid = true;
}

const bindPeople = async (section, data) => {
    let peoples = [];
    for (const people of data.peoples) {
        peoples.push({
            name: people.name,
            relationship: people.relationship,
            image: people.imageKey ? config.imagesbaseurl + people.imageKey : null,
            imageFile: null,
            imageKey: people.imageKey
        })
    }
    section.data = peoples;
    section.isValid = true;
}

const bindStories = async (section, data) => {
    let stories = [];
    for (const story of data.stories) {
        stories.push({
            title: story.title,
            date: story.date,
            description: story.description,
            image: story.imageKey ? config.imagesbaseurl + story.imageKey : null,
            imageFile: null,
            imageKey: story.imageKey
        })
    }
    section.data = stories;
    section.isValid = true;
}

const bindThemeData = async (section, data) => {
    let sliders = [];
    for (const slider of data.sliders) {
        sliders.push({
            image: slider.imageKey ? config.imagesbaseurl + slider.imageKey : null,
            imageFile: null,
            imageKey: slider.imageKey
        })
    }
    section.data = sliders;
    section.isValid = true;
}